export const glossary = {
  activeVolunteer: {
    title: "Active Volunteers",
    description: "Count of volunteers who have completed one or more visits within the chosen time frame"
  },
  totalVolunteer: {
    title: "Total Volunteers",
    description: "Total number of Volunteer who are 'Active Volunteers' + Volunteers who are present in the System."
  },
  totalVisits: {
    title: "Total Visits",
    description: "This represents the total number of visits that have been approved by the Care Coordinator."
  },
  ongoingVisits: {
    title: "Ongoing Visits",
    description: "This represents the visits that are not yet completed. These types of visits can either be pending approval or rejected."
  },
  careHours: {
    title: "Care hours",
    description: "The total number of hours spent on direct and indirect care activities."
  },
  travelHours: {
    title: "Travel Hours",
    description: "The total time spent traveling to and from patient locations."
  },
  savings: {
    title: "Savings",
    description: "Savings is calculated as Direct Care hours * Wages Per Hours."
  },
  totalMileage: {
    title: "Total Mileage",
    description: "Total Mileage represents the combined distance traveled by volunteers for both direct patient care and indirect care hours.The Mileage Value ($) is determined by Total Mileage × Mileage Rate."
  },
  formsSubmitted: {
    title: "Forms Submitted",
    description: "Total Forms submitted by volunteers"
  },
  patientsServed: {
    title: "Patients Served",
    description: "Number of patients served in the chosen time frame"
  }
}